var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "context/ThemeContext";
import { Button, ButtonPropTypes } from "./Button";
const PrimaryButton = (_a) => {
    var { disabled, inValid, style = {} } = _a, resProps = __rest(_a, ["disabled", "inValid", "style"]);
    const { theme } = useTheme();
    const primaryStyle = Object.assign({ opacity: disabled || inValid ? "65%" : undefined, backgroundColor: theme.primaryColor, color: "#fff" }, style);
    return _jsx(Button, Object.assign({}, resProps, { style: primaryStyle, disabled: disabled }));
};
PrimaryButton.propTypes = ButtonPropTypes;
export default PrimaryButton;
